export default __webpack_public_path__ + "static/media/Webinar.c97741e9.png";